import React, { createContext, useEffect, useState } from "react";
import { PropsType } from "../../interfaces/ChildrenType";
import { LedgersResponse } from "../../interfaces/UserData";
import { LedgerResultContextType } from "./ledger-types";

const LedgerData = sessionStorage.getItem("pepper-user-ledger");
const initialState: LedgerResultContextType = {
  ledgerResult: JSON.parse(LedgerData as string) || undefined,

  setLedgerResult: () => { },
};

export const LedgerResultContext = createContext(initialState);

export const LedgerResultContextProvider: React.FC<PropsType> = ({
  children,
}) => {
  const [ledgerResult, setLedgerResult] = useState<
  LedgersResponse | undefined
  >(initialState.ledgerResult);

  useEffect(() => {
    if (ledgerResult) {
      sessionStorage.setItem('pepper-user-ledger', JSON.stringify(ledgerResult))
    } else {
      sessionStorage.removeItem("pepper-user-ledger");
    }
  }, [ledgerResult])

  return (
    <LedgerResultContext.Provider
      value={{ ledgerResult, setLedgerResult }}
    >
      {children}
    </LedgerResultContext.Provider>
  );
};
